/**
 * @file Contains helper functions for TextInput component
 */
import { TextFieldProps } from '@mui/material';

import translate from '../../../i18n/translate';

/**
 * Get error and helper text for the input
 *
 * @param shouldCheckRequired Whether to check if input is required
 * @param value               The value of the input
 * @param maxLength           Max length of the input (optional)
 *
 * @returns                   Object with error(boolean) and helperText(string) properties
 */
export const getValidityProps = (
  shouldCheckRequired: boolean,
  value: HTMLInputElement['value'],
  maxLength?: HTMLInputElement['maxLength'],
): {
  error: NonNullable<TextFieldProps['error']>;
  helperText: NonNullable<TextFieldProps['helperText']>;
} => {
  if (shouldCheckRequired && value.trim().length === 0) {
    return {
      error: true,
      helperText: translate('GENERAL__FILL_FIELD'),
    };
  }

  if (maxLength !== undefined && value.length > maxLength) {
    return {
      error: true,
      helperText: translate('TITLE__MAX_LENGTH'),
    };
  }

  return { error: false, helperText: '' };
};
